export default [
  {
    description: 'Grupo',
    path: '/ged/gedgrupo',
    name: 'gedgrupo',
    component: () => import('@/views/ged/gedgrupo/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Grupo',
    parent: 'gedgrupo',
    path: '/ged/gedgrupo/cadastro/:id?',
    name: 'gedgrupo-create',
    component: () => import('@/views/ged/gedgrupo/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
  {
    description: 'Indexação de Grupo',
    parent: 'gedgrupo',
    path: '/ged/gedgrupo/:id/indexacao',
    name: 'gedgrupo-indexacao',
    component: () => import('@/views/ged/gedgrupo/GridIndexacao.vue'),
    goesToMenu: false,
  },
];
